import ThemeToggle from "./ThemeToggle";
import SettingsMenu from "./SettingsMenu";

// Pływająca kontrolka w prawym-górnym rogu dla stron bez nagłówka (logowanie, rejestracja,
// reset hasła). Domyślnie jeden przycisk 🌐 → język · waluta · motyw (spójne z belką landingu
// i konta). `themeOnly` (logowanie admina) pokazuje sam motyw — bez języka/waluty.
export default function FloatingControls({ themeOnly = false }: { themeOnly?: boolean }) {
  return (
    <div className="fixed right-4 top-4 z-[100] flex items-center gap-2">
      {themeOnly ? <ThemeToggle /> : <SettingsMenu />}
    </div>
  );
}
